'use client';

import { Button, Stack, Text } from '@backyard-ui/core';

import {
  type ReviewId,
  type GoodFeedbackAmount,
  type BadFeedbackAmount,
} from '@/infra/services/catalog/review/model';
import { algolia } from '@/infra/tracking/algolia';

import { useActions } from './hooks';

interface ActionsProps {
  reviewId: ReviewId;
  goodFeedbackAmount: GoodFeedbackAmount;
  badFeedbackAmount: BadFeedbackAmount;
}

function Actions(props: ActionsProps) {
  const {
    badFeedbackAmount: initialBadFeedbackAmount,
    goodFeedbackAmount: initialGoodFeedbackAmount,
    reviewId,
  } = props;

  const {
    badFeedbackAmount,
    goodFeedbackAmount,
    isHelpfulClicked,
    isInappropriateClicked,
    sendBadFeedBack,
    sendGoodFeedBack,
    sendInappropriateFeedBack,
  } = useActions({
    initialBadFeedbackAmount,
    initialGoodFeedbackAmount,
    reviewId,
  });

  return (
    <Stack
      spacing="4"
      direction={{ initial: 'column', md: 'row' }}
      align={{ initial: 'flex-start', md: 'center' }}
    >
      <Text size="lg">Útil?</Text>
      <Stack spacing="4" direction="row" align="center" isWrap>
        <Button
          size="xs"
          variant="outline"
          appearance="neutral"
          onClick={() => {
            algolia.sendPdpClickEvent();
            sendGoodFeedBack();
          }}
          isDisabled={isHelpfulClicked}
        >
          {`Sim \u22C5 ${goodFeedbackAmount}`}
        </Button>
        <Button
          size="xs"
          variant="outline"
          appearance="neutral"
          onClick={() => {
            algolia.sendPdpClickEvent();
            sendBadFeedBack();
          }}
          isDisabled={isHelpfulClicked}
        >
          {`Não \u22C5 ${badFeedbackAmount}`}
        </Button>
        <Button
          size="xs"
          variant="outline"
          appearance="neutral"
          onClick={() => {
            algolia.sendPdpClickEvent();
            sendInappropriateFeedBack();
          }}
          isDisabled={isInappropriateClicked}
          data-testid="inappropriate-button"
        >
          {isInappropriateClicked ? (
            <span>Denunciado</span>
          ) : (
            <div>
              <span className="block md:hidden">Inapropriado</span>
              <span className="hidden md:block">Conteúdo inapropriado</span>
            </div>
          )}
        </Button>
      </Stack>
    </Stack>
  );
}

export default Actions;
